// src/components/results/FinalResultItem.jsx

import React from "react";
import SingleQuestionInfoCard from "./Utility/Info";
import PronunciationAnalysis from "./Utility/Pronounciation";
import GrammarErrorCard from "./Utility/GrammarError";
import NewVocabCard from "./Utility/NewVocab";
import ExplanationCard from "./Utility/ExplanationCard";

const FinalResultItem = ({ resultItem , onRetry}) => {
  if (!resultItem) return null;

  const {
    question,
    verdict,
    local_url,
    user_answer_text,
    correct_solution,
    comments,
    pronounciation_result,
    grammar_error,
    new_vocab,
    status
  } = resultItem;

  return (
    <div className="py-6">
      {/* 1) Info card */}
      <SingleQuestionInfoCard
        question={question}
        verdict={verdict}
        userAnswerText={user_answer_text}
        localUrl={local_url}
        status={status}
        onRetry={onRetry}
      />

      <ExplanationCard
        correctAnswer= {correct_solution}
        comments={comments}
      />

      {/* 2) Pronunciation */}
      <PronunciationAnalysis
       text={user_answer_text}
      />

      {/* 3) Grammar errors */}
      {Array.isArray(grammar_error) &&
        grammar_error.map((item, idx) => (
          <GrammarErrorCard key={`gram-${idx}`} item={item} />
        ))}

      {/* 4) New vocab */}
      {Array.isArray(new_vocab) &&
        new_vocab.map((v, idx) => <NewVocabCard key={`vocab-${idx}`} vocab={v} />)}
    </div>
  );
};

export default FinalResultItem;
